/**
 * Programmatic navigation that behaves exactly like clicking a boosted link:
 * a real `<a href>` inheriting hx-boost from <body>, so htmx does the XHR +
 * body swap and pushes history (Alpine stores and in-flight uploads survive).
 * Use instead of `window.location.href = …` (CLAUDE.md "Navigation & Refresh
 * Responses"). `attrs` are set on the anchor (e.g. a save-gate marker).
 */
export function boostedNavigate(url: string, attrs: Record<string, string> = {}) {
  const a = document.createElement("a");
  a.setAttribute("href", url);
  for (const [k, v] of Object.entries(attrs)) a.setAttribute(k, v);
  a.hidden = true;
  document.body.appendChild(a);
  // Registers the boost handler (inherits hx-boost from <body>). Without htmx
  // the click falls through to a normal browser navigation.
  (window as any).htmx?.process?.(a);
  a.click();
  // Deliberately NOT removed here: htmx fires the request's lifecycle events
  // (beforeSwap/afterSwap, which document-level listeners like the build-skew
  // guard rely on) on this element, and a detached element's events never
  // bubble to document. The boosted body swap removes it; a blocked nav leaves
  // an inert hidden anchor until the next swap.
}
